import {
  InlineLoadingSpinner,
  SdnUserProvider,
} from '@spins-gcp/shared-components-react';
import { MimicProvider } from '../../contexts/mimic-provider';
import { SdnApolloProvider } from '../sdn-apollo/sdn-apollo-provider';
import { DaapAccessGuard } from '../auth/daap-access-guard';
import App from '../../app';
import { Suspense, useState } from 'react';
import { CookiesProvider } from 'react-cookie';
import { Provider } from 'jotai';
import { MimicTarget } from '../../types/MimicTarget';

export const AppProvider = () => {
  const [mimicState, setMimicState] = useState<MimicTarget | undefined>(
    undefined
  );

  return (
    <CookiesProvider>
      <Suspense fallback={<InlineLoadingSpinner />}>
        <SdnApolloProvider mimicState={mimicState}>
          <MimicProvider onMimicChange={setMimicState}>
            {/* Inside MimicProvider so it still clears stale mimic state while the check runs */}
            <DaapAccessGuard>
              <SdnUserProvider>
                <Provider>
                  <App />
                </Provider>
              </SdnUserProvider>
            </DaapAccessGuard>
          </MimicProvider>
        </SdnApolloProvider>
      </Suspense>
    </CookiesProvider>
  );
};
